import { oneOf, string } from 'prop-types'
import { useContext } from 'react'
import { useSlateStatic } from 'slate-react'
import cc from 'classcat'

import { LIST_TYPES } from '../serialization'
import { ToolbarContext } from '../RichTextEditor'
import { getList, toggleList } from '../lists'
import { isButtonFocused } from '../buttons'
import { isQuote } from './QuoteButton'

export default function ListButton({ title, format }) {
  const editor = useSlateStatic()
  const [{ isLinkTooltipOpen, isColorPickerOpen, isButtonLinkTooltipOpen }] = useContext(ToolbarContext)

  const { isList } = getList(editor, format)

  function handleMouseDown(event) {
    event.preventDefault()

    toggleList(editor, format)
  }

  return (
    <button
      className={cc([
        'dali-plugin-text-toolbar-button',
        `dali-plugin-text-toolbar-button-${format}`,
        { active: isList },
      ])}
      data-command-name={format}
      type="button"
      title={title}
      disabled={
        (!editor.selection && !isLinkTooltipOpen && !isColorPickerOpen && !isButtonLinkTooltipOpen) ||
        isQuote(editor) ||
        isButtonFocused(editor) ||
        isButtonLinkTooltipOpen
      }
      onMouseDown={handleMouseDown}
    />
  )
}

ListButton.propTypes = { title: string.isRequired, format: oneOf(LIST_TYPES) }
